
// pgw 07-dec-2025 includes changes

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";

import {
  packSetlist,
  cacheAssets,
  uncacheAssets,
} from "./setlistsAPI";
import initialState from "./initialState";
import initialSessionState from "../session/initialState";

import {
  unpackSession,
  unpackSetlist,
} from "../session/sessionAPI";
import { removeAssetFromCache } from "../../services/assetStore";
import { triggerBlobDownload } from "../../factories/ui";
import { addNotificationAsync } from "../ui/uiSlice";

// pgw 30-sep-2025 - replace all debugging debugLog calls with debugLog
import { debugLog } from '../../debugLog';

export const cacheSetlistAssetsAsync = createAsyncThunk(
  "setlists/cacheSetlist",
  async (payload, thunkAPI) => {

// pgw 05-nov-2025
	console.log('cacheSetlistAssetsAsync payload.items.length = ', payload.items.length)
	console.log('cacheSetlistAssetsAsync payload.id = ', payload.id)

	debugLog('cacheSetlistAssetsAsync payload.items.length = ', payload.items.length)

    if (payload.items.length === 0) {
	console.log('Should not cache setlist because there are no songs in it ')
      // Should not cache setlist because there are no songs in it
    } else {
      const setlist = {
        ...thunkAPI
          .getState()
          .setlists.setlists.find((s) => s.id === payload.id),
      };

	console.log('cacheSetlistAssetsAsync setlist = ', setlist)
	console.log('cacheSetlistAssetsAsync setlist.setlists = ', setlist.setlists)

      const assetUrls = [];
      for (const setlistSong of setlist.items) {

	console.log('cacheSetlistAssetsAsync setlistSong = ', setlistSong)
	console.log('cacheSetlistAssetsAsync setlistSong.pathzip = ', setlistSong.pathzip)
	console.log('cacheSetlistAssetsAsync setlistSong.lyricsUrl = ', setlistSong.pathzip)

        assetUrls.push(setlistSong.pathzip);

        // Add lyrics asset if song has it
        if (setlistSong.lyricsUrl) assetUrls.push(setlistSong.lyricsUrl);
      }

      await cacheAssets(assetUrls, (perentage) => {
        thunkAPI.dispatch(setCacheProgress(perentage));
      });
      setlist.cached = true;
      return setlist;
    }
  }
);

export const uncacheSetlistAssetsAsync = createAsyncThunk(
  "setlists/uncacheSetlist",
  async (payload, thunkAPI) => {

	debugLog('uncacheSetlistAssetsAsync p1 ')

    const setlist = {
      ...thunkAPI.getState().setlists.setlists.find((s) => s.id === payload.id),
    };
    const setlists = thunkAPI.getState().setlists.setlists;

    const setlistsWhichContainUrl = (urlToCheck) => {
      return setlists.filter((setlist) =>
        setlist.items.find((song) => song.pathzip === urlToCheck)
      );
    };
    const assetUrls = [];
    for (const setlistSong of setlist.items) {
      if (setlistsWhichContainUrl(setlistSong.pathzip).length < 2) {
        assetUrls.push(setlistSong.pathzip);
        // Add lyrics asset if song has it
        if (setlistSong.lyricsUrl) assetUrls.push(setlistSong.lyricsUrl);
      } else {
        // Found track into another playlist
      }
    }

    await uncacheAssets(assetUrls, (perentage) => {
      thunkAPI.dispatch(setCacheProgress(perentage));
    });

    setlist.cached = false;
    return setlist;
  }
);

export const unpackSessionAsync = createAsyncThunk(
  "session/unpack",
  async (payload, thunkAPI) => {
	debugLog('unpackSessionAsync p1 ')
    const sessionObject = await unpackSession(payload);
    return sessionObject;
  }
);

export const unpackSetlistAsync = createAsyncThunk(
  "session/unpackSetlist",
  async (payload, thunkAPI) => {
	debugLog('unpackSetlistAsync p1 ')
    const setlistObject = await unpackSetlist(payload);
    const setlistSessions = [];

    for (const setlistKey of Object.getOwnPropertyNames(setlistObject)) {
      const sessionBlob = setlistObject[setlistKey];
      const sessionObject = await unpackSession(sessionBlob);
      setlistSessions.push(sessionObject);
    }

    return setlistSessions;
  }
);

export const packSetlistAsync = createAsyncThunk(
  "session/packSetlist",
  async (payload, thunkAPI) => {
	debugLog('packSetlistAsync p1 ')
    // Get setlist session from state
    // Filter out all containing userAudio stems
    const sessions = thunkAPI
      .getState()
      .setlist.sessions.filter((s) => s.userStems.length === 0);

    // Add all session zips into one master .setlist zip file
    const setListBlob = await packSetlist(sessions);

    // Prompt download in browser 👍
    const dateNow = new Date();
    const setlistFilename = `mySetlist-${dateNow
      .toLocaleDateString()
      .replaceAll("/", "")}_${dateNow
      .toLocaleTimeString()
      .replaceAll(":", "")}.setlist`;
    triggerBlobDownload(setListBlob, setlistFilename);

	// pgw 13-jul-2025 remove notifications, as they mess with setlists and can break player rendering
	/*
    thunkAPI.dispatch(
      addNotificationAsync({
        title: "Setlist saved",
        text: `${setlistFilename} was downloaded`,
        type: "positive",
      })
    );
	*/

    return true;
  }
);

export const removeSessionFromSetlistAsync = createAsyncThunk(
  "setlsit/remove",
  async (payload, thunkAPI) => {
	debugLog('removeSessionFromSetlistAsync p1 ')
    // Remove associated items from cache
    const session = thunkAPI
      .getState()
      .setlist.sessions.find((s) => s.id === payload);
    for (const userStem of session.userStems) {
      await removeAssetFromCache(userStem.id);
    }
    // Remove associated song zip
    await removeAssetFromCache(session.song.pathzip);

    return payload;
  }
);

// pgw 16-jul-2025
// chatgpt solution:
/*
import { v4 as uuidv4 } from 'uuid';
import { sleep } from '../../utils/sleep'; // or define inline
import { persistor } from '../../store';
import { addSetlist } from './setlistsSlice';


reducers: {
  addSetlist: (state, action) => {
    state.setlists.push(action.payload);
  },
}


export const createNewEmptySetlist = (title, subtitle, imageUrl) => async (dispatch) => {
  const newSetlist = {
    id: uuidv4().slice(0, 8),
    title,
    subTitle: subtitle,
    imageUrl,
    createdAt: new Date().toISOString(),
    lastUpdatedAt: new Date().toISOString(),
    cached: false,
    items: [],
    readOnly: false,
  };

  dispatch(addSetlist(newSetlist));

  await sleep(100);
  await persistor.flush();
};
export const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
dispatch(createNewEmptySetlist('My Setlist', 'Optional subtitle', '/some/image.png'));


explain these:  thunk action ,  Redux Thunk , createAsyncThunk 

In Redux, a thunk is a function that delays logic (like side effects) until it’s ready to be executed by the Redux store.
Formally: A thunk is a function that returns another function.
e.g.
const thunkAction = () => (dispatch, getState) => {
  // this runs when you dispatch it
  debugLog("Thunk executing...");
  dispatch({ type: 'SOME_ACTION' });
};




import { v4 as uuidv4 } from 'uuid';
import { sleep } from '../../utils/sleep'; // or define inline
import { persistor } from '../../store';
import { addSetlist } from './setlistsSlice';

export const createNewEmptySetlist = (title, subtitle, imageUrl) => async (dispatch) => {
  const newSetlist = {
    id: uuidv4().slice(0, 8),
    title,
    subTitle: subtitle,
    imageUrl,
    createdAt: new Date().toISOString(),
    lastUpdatedAt: new Date().toISOString(),
    cached: false,
    items: [],
    readOnly: false,
  };

  dispatch(addSetlist(newSetlist));

  await sleep(100);
  await persistor.flush();
};


*/



export const setlistsSlice = createSlice({
  name: "setlists",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    createNewEmptySetlist: (state, action) => {
		debugLog('createNewEmptySetlist p1 ')
      const newSetlist = {
        id: uuidv4().slice(0, 8),
        title: action.payload.title,
        subTitle: action.payload.subtitle,
        imageUrl: action.payload.imageUrl,
        createdAt: new Date().toISOString(),
        lastUpdatedAt: new Date().toISOString(),
        cached: false,
        items: [],
        readOnly: false
      };
      state.setlists.push(newSetlist);
    },
    createSetlistFromData: (state, action) => {
		debugLog('createSetlistFromData p1 ')

	  console.log("[SETLISTS SLICE] createSetlistFromData state = ", state);
	  console.log("[SETLISTS SLICE] createSetlistFromData action = ", action);

      const newSetlist = {
        id: action.payload.setlistId || uuidv4().slice(0, 8),
        title: action.payload.title,
        subTitle: action.payload.subtitle,
        imageUrl: action.payload.imageUrl,
        createdAt: new Date().toISOString(),
        lastUpdatedAt: new Date().toISOString(),
        cached: false,
        items: action.payload.items,
        readOnly: action.payload.readOnly
      };
	  console.log("[SETLISTS SLICE] createSetlistFromData action.payload = ", action.payload);
	  console.log("[SETLISTS SLICE] createSetlistFromData newSetlist = ", newSetlist);
      state.setlists.push(newSetlist);
    },
    removeSetListFromSetlists: (state, action) => {
		debugLog('removeSetListFromSetlists p1 ')
      state.setlists = state.setlists.filter(
        (setlist) => setlist.id !== action.payload
      );
    },
    setCacheProgress: (state, action) => {
      state.cachingProgress = action.payload;
    },

    addSongToSetlist: (state, action) => {

		// pgw 24-sep-2025
		debugLog('addSongToSetlist state = ', state)
		debugLog('addSongToSetlist action = ', action)
		debugLog('addSongToSetlist state.setlists = ', state.setlists)
		debugLog('addSongToSetlist action.payload = ', action.payload)


      const setlist = state.setlists.find(
        (setlist) => setlist.id === action.payload.setlistId
      );
      if (setlist) {

		debugLog('addSongToSetlist setlist = ', setlist)
		debugLog('addSongToSetlist setlist.items = ', setlist.items)
		debugLog('addSongToSetlist setlist.title = ', setlist.title)
		debugLog('addSongToSetlist setlist.cached = ', setlist.cached)
		debugLog('addSongToSetlist setlist.readOnly = ', setlist.readOnly)

		if (setlist.cached) {
			debugLog('addSongToSetlist setlist.cached => alert user that song will not be cached')
// 
// 
// 			let res = confirm("That setlist is set to be available offline.\nDo you want to continue (OK to add anyway; Cancel to do nothing) ?")
// 			debugLog('res = ', res);
// 

			let confStr = "That setlist is set to be available offline."
			confStr = confStr + "\n" + "However, that is only true for songs that are already in that setlist."
			confStr = confStr + "\n" + "If you add this song, it will NOT be available offline."
			confStr = confStr + "\n" + "To make all songs in that setlist available offline"
			confStr = confStr + "\n" + "you need to do the following:"
			confStr = confStr + "\n" + '. change the setlist so that "Available offline" is off,'
			confStr = confStr + "\n" + '. add this song to that setlist,'
			confStr = confStr + "\n" + '. change the setlist so that "Available offline" is on.'
			confStr = confStr + "\n" + "\n" + "Are you sure you want to continue ?"
			confStr = confStr + "\n" + "(OK to add this song to the setlist; Cancel to do nothing)"
			let res = confirm(confStr)
			if (res) {
				debugLog("You pressed OK!");
			} else {
				debugLog("You pressed Cancel - returning...");
				return;
			}



		}
		else {
			debugLog('addSongToSetlist setlist.cached false => no need to alert user')
		}


        if (
          !setlist.items.find(
            (song) => song.songId === action.payload.song.songId
          )
        ) {
          setlist.items = [...setlist.items, action.payload.song];
        }
      }
      state.setlists = [...state.setlists];
    },
    removeSongFromSetlist: (state, action) => {
      const setlist = state.setlists.find(
        (setlist) => setlist.id === action.payload.setlistId
      );
      if (setlist) {
        setlist.items = [
          ...setlist.items.filter(
            (song) => song.songId !== action.payload.song.songId
          ),
        ];
      }
      state.setlists = [...state.setlists];
    },


	// features/setlists/setlistsSlice.js

	updateSetlistItemSettings: (state, action) => {
	  const { setlistId, itemIx, itemSettings } = action.payload || {};
	  if (!setlistId && setlistId !== "") return;
	  if (typeof itemIx !== "number") return;

	  // This slice stores setlists in state.setlists (array), not byId.
	  const setlist = (state.setlists || []).find(s => s.id === setlistId);
	  const item = setlist?.items?.[itemIx];
	  if (!item) {
		console.log("[SETLISTS SLICE] updateSetlistItemSettings target item missing", {
		  setlistId,
		  itemIx,
		  hasSetlist: !!setlist,
		  itemsLen: setlist?.items?.length,
		});
		return;
	  }

	  // MUST match what Setlist open reads.
	  item.itemSettings = itemSettings || null;

	  // Force immutability at the top level so selectors rerender.
	  state.setlists = [...state.setlists];

	  console.log("[SETLISTS SLICE] updateSetlistItemSettings applied", {
		setlistId,
		itemIx,
		stemCount: itemSettings?.stems?.length,
	  });
	},



/*
		// pgw 30-jan-2026
	updateSetlistItemSettings: (state, action) => {
	  const { setlistId, itemIx, itemSettings } = action.payload;

	  console.log("[SETLISTS SLICE] updateSetlistItemSettings called", {
		setlistId,
		itemIx,
		hasSettings: !!itemSettings,
		stemCount: itemSettings?.stems?.length,
		stemsPreview: itemSettings?.stems?.map(s => ({
		  index: s.index,
		  level: s.level
		}))
	  });

	  const list = state.byId?.[setlistId];
	  const item = state.byId?.[setlistId]?.items?.[itemIx];


	  console.log("[SETLISTS SLICE] updateSetlistItemSettings applied", {
		setlistId,
		itemIx,
		hasItem: !!item,
		itemKeys: item ? Object.keys(item) : null,
		stems: itemSettings?.stems?.map(s => ({ index: s.index, level: s.level })),
	  });



	  console.log("[SETLISTS SLICE] updateSetlistItemSettings target item", {
		exists: !!item,
		songId: item?.songId,
		before: item?.itemSettings?.stems?.map(s => ({
		  index: s.index,
		  level: s.level
		}))
	  });

	  if (!item) {
	  	console.log("[SETLIST SLICE] updateSetlistItemSettings item null or undefined -> returning !!!" )
		return;
	  }

	  item.itemSettings = itemSettings;

	  console.log("[SETLIST SLICE] updateSetlistItemSettings after write", {
		after: item.itemSettings?.stems?.map(s => ({
		  index: s.index,
		  level: s.level
		}))
	  });
	}

*/


  },
  extraReducers: (builder) => {
    builder
      .addCase(removeSessionFromSetlistAsync.fulfilled, (state, action) => {
        state.sessions = state.sessions.filter((s) => s.id !== action.payload);
      })
      .addCase(packSetlistAsync.pending, (state, action) => {})
      .addCase(packSetlistAsync.rejected, (state, action) => {
        state.status = "error";
        console.error(action);
      })
      .addCase(packSetlistAsync.fulfilled, (state, action) => {})
      .addCase(cacheSetlistAssetsAsync.pending, (state, action) => {
        state.status = "caching";
        state.cachingProgress = 0.01;
      })
      .addCase(cacheSetlistAssetsAsync.rejected, (state, action) => {
        state.status = "error";
        console.error(action);
        state.cachingProgress = null;
      })
      .addCase(cacheSetlistAssetsAsync.fulfilled, (state, action) => {
        let existingSetlists = [...state.setlists];
        existingSetlists.find(
          (setlist) => setlist.id === action.payload.id
        ).cached = true;
        state.cachingProgress = null;
        state.setlists = existingSetlists;
        state.status = "idle";
      })
      .addCase(uncacheSetlistAssetsAsync.pending, (state, action) => {
        state.status = "uncaching";
      })
      .addCase(uncacheSetlistAssetsAsync.rejected, (state, action) => {
        state.status = "error";
        state.cachingProgress = null;
      })
      .addCase(uncacheSetlistAssetsAsync.fulfilled, (state, action) => {
        let existingSetlists = [...state.setlists];
        existingSetlists.find(
          (setlist) => setlist.id === action.payload.id
        ).cached = false;
        state.cachingProgress = null;
        state.setlists = existingSetlists;
        state.status = "idle";
      })

      .addCase(unpackSessionAsync.pending, (state, action) => {
        state.status = "unpacking";
        state.loadingProgress = 7;
      })
      .addCase(unpackSessionAsync.rejected, (state, action) => {
        state.status = "error";
        console.error(action);
      })
      .addCase(unpackSessionAsync.fulfilled, (state, action) => {
        Object.getOwnPropertyNames(action.payload).forEach((propertyName) => {
          state[propertyName] = action.payload[propertyName];
        });
        const newSession = {
          ...action.payload,
          id: uuidv4().slice(0, 8),
          imported: true,
          importedAt: new Date().toISOString(),
        };
        state.sessions.push(newSession);
        state.status = "ready";
        state.loadingProgress = 10;
      })
      .addCase(unpackSetlistAsync.fulfilled, (state, action) => {
        const sessionPack = [];

        for (const session of action.payload) {
          const importedSession = {};
          Object.getOwnPropertyNames(session).forEach((propertyName) => {
            importedSession[propertyName] = session[propertyName];
          });
          const newSession = {
            ...importedSession,
            id: uuidv4().slice(0, 8),
            imported: true,
            importedAt: new Date().toISOString(),
          };
          sessionPack.push(newSession);
        }
        state.sessions = [...state.sessions, ...sessionPack];
      });
  },
});

export const {
  createNewEmptySetlist,
  createSetlistFromData,
  removeSetListFromSetlists,
  addSongToSetlist,
  removeSongFromSetlist,
  setCacheProgress,
  updateSetlistItemSettings,
} = setlistsSlice.actions;



export const selectSetlistsSetlists = (state) => state.setlists.setlists;
export const selectSetlistsCachingProgress = (state) =>
  state.setlists.cachingProgress;
export const selectSetlistsStatus = (state) => state.setlists.status;
export default setlistsSlice.reducer;
